import _                                                                                                   from 'underscore';
import React, { FC, useMemo }                                                                              from 'react';
import { DragDropContext, DragDropContextProps, Droppable, DroppableProps, DropResult, ResponderProvided } from 'react-beautiful-dnd';
import classNames                                                                                          from 'classnames';
import { ClassValue }                                                                                      from 'classnames/types';


interface Props {
    id?: string,
    containerClasses?: ClassValue,
    dragContextProps?: Partial<DragDropContextProps>,
    droppableProps?: Partial<DroppableProps>,

    onDragEnd( result: DropResult, provided: ResponderProvided ): void,
}

const defaultProps: Props = {
    id:               'draggableItems',
    containerClasses: [],
    onDragEnd:        ( result: DropResult ) => {},
    dragContextProps: null,
    droppableProps:   null,
}

const DraggableContainer: FC<Props> = ( props ) => {

    let containerClasses = useMemo( () => classNames( props.containerClasses ), [ props.containerClasses ] );

    return (
        <DragDropContext { ...props.dragContextProps } onDragEnd={ props.onDragEnd }>

            <Droppable droppableId={ props.id } { ...props.droppableProps }>

                { ( provided, snapshot ) => {

                    return (
                        _.isFunction( props.children )
                        ? ( props.children( provided, snapshot ) )
                        : (
                            <div { ...provided.droppableProps } ref={ provided.innerRef } className={ containerClasses }>

                                { props.children }

                                { provided.placeholder }

                            </div>
                        ) )

                } }

            </Droppable>

        </DragDropContext>
    );
};

DraggableContainer.defaultProps = defaultProps;

export { DraggableContainer };
